import { motion } from "framer-motion";

const ENTER_VARIANTS = {
  down: { initial: { y: 0 }, animate: { y: "100%" } },
  up: { initial: { y: 0 }, animate: { y: "-100%" } },
  left: { initial: { x: 0 }, animate: { x: "-100%" } },
  right: { initial: { x: 0 }, animate: { x: "100%" } },
  fade: { initial: { opacity: 1 }, animate: { opacity: 0 } },
};

const TRANSITION = { duration: 1.2, ease: [0.33, 1, 0.68, 1] };
const FADE_TRANSITION = { duration: 0.7, ease: [0.22, 1, 0.36, 1] };

export default function PageEnterOverlay({
  show,
  mode = "curtain",
  direction = "down",
  bgClass = "bg-darkBrown",
}) {
  if (!show) return null;
  const variant =
    mode === "fade"
      ? ENTER_VARIANTS.fade
      : ENTER_VARIANTS[direction] || ENTER_VARIANTS.down;

  return (
    <motion.div
      className={`fixed inset-0 z-50 ${bgClass}`}
      initial={variant.initial}
      animate={variant.animate}
      transition={mode === "fade" ? FADE_TRANSITION : TRANSITION}
      aria-hidden="true"
      style={{ willChange: mode === "fade" ? "opacity" : "transform" }}
    />
  );
}
